import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { primaryColor } from "../hooks/useFirstTimeRegister";

export default function RegisterFormColumnHeader({ onBackClick }) {
  return (
    <>
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <Box
          component="img"
          src="./ProbateBondPros.png"
          alt="Probate Bond Pros Logo"
          sx={{
            height: 60,
            maxWidth: "100%",
            filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.2))",
          }}
        />
      </Box>

      <Box sx={{ textAlign: "center", mb: 2 }}>
        <Box
          sx={{
            position: "absolute",
            top: 40,
            left: 0,
            "@media (max-width: 768px)": {
              left: -10,
            },
          }}
        >
          <IconButton
            onClick={onBackClick}
            sx={{
              color: primaryColor,
              backgroundColor: "rgba(51, 51, 51, 0.1)",
              "&:hover": {
                backgroundColor: "rgba(51, 51, 51, 0.2)",
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ textAlign: "center", mb: 2 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: primaryColor,
            mb: 0.5,
            fontSize: { xs: "1.6rem", sm: "1.8rem" },
          }}
        >
          Create Your Account
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            fontWeight: 400,
          }}
        >
          Join our platform today
        </Typography>
      </Box>
    </>
  );
}

RegisterFormColumnHeader.propTypes = {
  onBackClick: PropTypes.func.isRequired,
};
